function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "copy (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21014",
    d: "M16.571 8.857v7.714H8.857V8.857h7.714m0-.857H8.857A.857.857 0 0 0 8 8.857v7.714a.857.857 0 0 0 .857.857h7.714a.857.857 0 0 0 .857-.857V8.857A.857.857 0 0 0 16.571 8z",
    transform: "translate(-5.429 -5.429)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21015",
    d: "M2.857 8.857H2v-6A.857.857 0 0 1 2.857 2h6v.857h-6z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#203662"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyImage);
export default __webpack_public_path__ + "static/media/CopyImage.c734d93473bc733fc24ff1c691be1dc1.svg";
export { ForwardRef as ReactComponent };